import { GoogleMap } from '@react-google-maps/api'
import { Box, Typography, IconButton } from '@mui/material'

import MapMarkerGreen from 'src/assets/files/map-marker-green.svg'
import { useTranslation } from 'react-i18next'
import { useStyles } from './../../styles'

import { MutableRefObject } from 'react'
import { ICoords } from 'src/types'
import { AppEvents, handleMapTypeIdChange } from 'admin-ui/src/constants'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { CustomMarker } from './custom-marker.component'

interface IProps {
  center: ICoords
  scannerLocation: ICoords
  scannerName?: string
  mapRef: MutableRefObject<google.maps.Map | null>
}

export const ConsumerScanMap = ({ center, scannerLocation, scannerName, mapRef }: IProps) => {
  const classes = useStyles()
  const [t] = useTranslation()

  const handleLoad = (map: google.maps.Map) => {
    mapRef.current = map

    handleMapTypeIdChange(map)
  }

  return (
    <GoogleMap
      onMapTypeIdChanged={() => {
        handleMapTypeIdChange(mapRef?.current)
      }}
      mapContainerClassName={classes.map}
      center={center}
      zoom={10}
      options={{
        clickableIcons: false,
        streetViewControl: false,
      }}
      onLoad={handleLoad}
    >
      {(scannerLocation.lat !== 0 || scannerLocation.lng !== 0) && (
        <CustomMarker
          icon={MapMarkerGreen}
          marker={scannerLocation}
          zIndex={2}
          info={
            <>
              <Typography
                sx={{
                  marginBottom: '6px',
                  fontSize: '12px',
                  color: '#000',
                  width: '100%',
                  textAlign: 'center',
                }}
                variant="h3"
              >
                {scannerName}
              </Typography>
              <Box
                sx={{
                  fontSize: '10px',
                  width: '100%',
                  textAlign: 'center',
                }}
              >
                Scanner location
              </Box>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                }}
              >
                <div>
                  <Typography sx={{ fontSize: '10px' }}>
                    {`Latitude: ${scannerLocation.lat}`}
                  </Typography>
                  <Typography sx={{ fontSize: '10px' }}>
                    {`Longitude: ${scannerLocation.lng}`}
                  </Typography>
                </div>
                <IconButton
                  onClick={() => {
                    navigator.clipboard.writeText(`${scannerLocation.lat} ${scannerLocation.lng}`)
                    const detail = { message: t('clipboard-copied-notification.v') }
                    const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
                    document.dispatchEvent(event)
                  }}
                >
                  <ContentCopyIcon className={classes.copyIcon} />
                </IconButton>
              </div>
            </>
          }
        />
      )}
    </GoogleMap>
  )
}
